/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BulkEditResultResponseResultsInner } from './BulkEditResultResponseResultsInner';
import {
    BulkEditResultResponseResultsInnerFromJSON,
    BulkEditResultResponseResultsInnerFromJSONTyped,
    BulkEditResultResponseResultsInnerToJSON,
} from './BulkEditResultResponseResultsInner';

/**
 * 
 * @export
 * @interface BulkEditResultResponse
 */
export interface BulkEditResultResponse {
    /**
     * 
     * @type {string}
     * @memberof BulkEditResultResponse
     */
    status: BulkEditResultResponseStatusEnum;
    /**
     * 
     * @type {Array<BulkEditResultResponseResultsInner>}
     * @memberof BulkEditResultResponse
     */
    results: Array<BulkEditResultResponseResultsInner>;
}


/**
 * @export
 */
export const BulkEditResultResponseStatusEnum = {
    Succeeded: 'succeeded',
    Partial: 'partial',
    Failed: 'failed'
} as const;
export type BulkEditResultResponseStatusEnum = typeof BulkEditResultResponseStatusEnum[keyof typeof BulkEditResultResponseStatusEnum];


/**
 * Check if a given object implements the BulkEditResultResponse interface.
 */
export function instanceOfBulkEditResultResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function BulkEditResultResponseFromJSON(json: any): BulkEditResultResponse {
    return BulkEditResultResponseFromJSONTyped(json, false);
}

export function BulkEditResultResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkEditResultResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'results': ((json['results'] as Array<any>).map(BulkEditResultResponseResultsInnerFromJSON)),
    };
}

export function BulkEditResultResponseToJSON(value?: BulkEditResultResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'results': ((value.results as Array<any>).map(BulkEditResultResponseResultsInnerToJSON)),
    };
}

